export const toggleSetValue = (item, value) => (
  item.has(value) ? item.remove(value) : item.add(value)
);

export const modify = (state, key, callback) => {
  const path = Array.isArray(key) ? key : [key];
  return state.setIn(path, callback(state.getIn(path)));
};
